import type { ButtonBarItem } from "@gearbox-protocol/deploy-tools-ui";
import type { TaskDefinitionFormSchema } from "api";
import { useMemo, useState } from "react";

export const TAB_DEFINITION = "@def";

export default function useTaskDefinitionViewNav(
  def: TaskDefinitionFormSchema,
) {
  const [tab, setTab] = useState(TAB_DEFINITION);

  const nav = useMemo(() => {
    if (!def.artifacts) {
      return undefined;
    }
    const newForkNav: ButtonBarItem[] = [
      {
        id: TAB_DEFINITION,
        title: "Definition",
      },
    ];
    def.artifacts.forEach(({ name }) => {
      newForkNav.push({
        id: name,
        title: name,
      });
    });
    return newForkNav;
  }, [def]);

  const artifact = useMemo(() => {
    return def.artifacts?.find(({ name }) => name === tab);
  }, [def, tab]);

  return { nav, tab, artifact, setTab };
}
